import createReducer from 'Lib/createReducer';

export const SAVE_TOC = 'SAVE_TOC';


const initialState = [];

const actionHandlers = {
  [SAVE_TOC]: (state, action) => {
    return [ ...action.data ];
  }
};


export default createReducer(initialState, actionHandlers);
